export default "__VITE_ASSET__CUlqRsUc__"